import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

export const Link = styled(RouterLink)`
  margin-top: 8px;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.pink};
  font-weight: 800;
  align-self: end;

  &::before {
    content: "←";
    color: ${({ theme }) => theme.colors.pink};
    margin-right: 10px;
    font-size: 18px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.darkPink};
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-column: 1;
  }
`;

export const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  padding: 5px;
  border: none;
  border-radius: 5px;
  justify-self: end;
  background-color: ${({ theme }) => theme.colors.pink};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkPink};
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;
  }
`;

export const JiraIssuesStyled = styled.div`
  margin: 8px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 30px auto;
`;
